

























import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import ActivityLabel from '@/components/common/edit/ActivityLabel.vue';
import Bridge from '@/common/bridge';
import getUrlParam from '@/common/utils/getUrlParam';
import { majorNoticeText } from '@/common/constants/index';

interface Payload {
  startTime?: number;
}

@Component({
  components: {
    'activity-label': ActivityLabel
  }
})
export default class ActivityStartTime extends Vue {
  @Getter('startTime') getterstartTime: any;
  @Getter('section') section: any;
  @Getter('xcxFlag') xcxFlag!: boolean;
  @Getter('xmMajordomo') xmMajordomo!: boolean;
  @Getter('xcxType') xcxType!: string;
  @Action('changeStartTime') changeStartTime!: Function;
  @Action('changeShowFooter') changeShowFooter!: Function;

  showDatePicker: boolean = false;
  type: string = getUrlParam('type') as string;

  mounted() {
    const isCopy = getUrlParam('state') == 'copy';
    isCopy &&
      setTimeout(() => {
        const payload: Payload = {
          startTime: Date.now()
        };
        this.changeStartTime(payload);
      }, 2000);
  }

  get startTimeStyle() {
    return {
      color: this.section.inputFontColor,
      backgroundColor: this.section.inputBackgroundColor
    };
  }

  get startTime(): number {
    return this.getterstartTime;
  }

  set startTime(val: number) {
    const payload: Payload = {
      startTime: val
    };
    this.changeStartTime(payload);
  }
  handleShow() {
    // 已发布的活动且活动已经开始,开始时间不能修改
    if (this.type === 'reEdit' && this.startTime < new Date().valueOf()) {
      return;
    }
    // 独立版小麦秀不可使用并弹框提示
    const origin = getUrlParam('origin');
    if (this.xcxType === 'mkb') {
      return;
    }
    if (this.xcxFlag && !this.xmMajordomo) {
      Vue.$confirm({
        oneBtn: true,
        title: '提示',
        text: majorNoticeText,
        okText: '确定'
      });
      return;
    }
    this.showDatePicker = true;
    this.changeShowFooter(false);
  }
  handleSetstartTime(value: number) {
    this.startTime = value;
    this.changeShowFooter(true);
  }
  handleCancle() {
    this.changeShowFooter(true);
  }
}
